import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
//import "react-tabs/style/react-tabs.css";
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import MakeARequest from './MakeARequest';
import RequestsToApprove from './RequestsToApprove';
import { IFair, IFairPromotionInfo, IFeedRequest } from './PromotionTypes';
import PromoteWizard from './PromoteWizard';
import PromotionHistory from './PromotionHistory';

const FairPromotionLinkingContainer = (props) => {
  const [data, setData] = useState<IFairPromotionInfo>();
  const [fairs, setFairs] = useState<IFair[]>([]);
  const [feederRequests, setFeederRequests] = useState<IFeedRequest[]>([]);
  const [feedRequests, setFeedRequests] = useState<IFeedRequest[]>([]);
  const [tabIndex, setTabIndex] = useState(1);  

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    store.server
      .getApi2<IFairPromotionInfo>('../FairPromotion/Info')
      .then((res: any) => {
        console.log(res);
        let { fairs, feederRequests, feedRequests } = res.Value;
        setData(res.Value);
        setFairs(fairs);
        setFeederRequests(feederRequests);
        setFeedRequests(feedRequests);
      })
      .catch((err) => {
        console.error(err);
        toast.error(err);
      });
  };

  return (
    <div className="">
      {/* <div className='flex-between'>
        <div>
          <h3>Entry Promotion Wizard</h3>        
        </div>

      </div> */}
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Overview</Tab>
          <Tab>Wizard</Tab>
          <Tab>Advancement History</Tab>
          <Tab>Make a Request (From this contest)</Tab>
          <Tab>Requests to Approve (To this contest)</Tab>
        </TabList>
        <TabPanel>
          <p>Welcome to the zFairs Advancement Wizard. You can promote or advance entries from this event to another event.</p>
          <div className="overview-section soft-border">
            <h4>To Advance Entries:</h4>
            <ol>
              <li>Navigate to the "Wizard" tab to start the advancement process.</li>
              <li>Select the entry pool you wish to advance and choose the target event. Later in the process will will be able to refine the entries to advance.</li>
              <li>
                Map the fields from the source event to the target event, using our mapping tool. This may include categories, custom questions, entry types, paperwork, packets, and other relevant
                information.
              </li>
              <li>Review and confirm the which entries and information will be advanced.</li>
              <li>Submit the advancement request for processing.</li>
            </ol>
          </div>
          <br/>
          <div className="overview-section soft-border">
            <h4>Advancement Trails:</h4>
            The request and approval process for allowing advancements into this and other events. This does not advance entries, but sets up the permissions needed for promotions.
            <h6>Request Permission</h6>
            <ol>
              <li>Navigate to the "Make a Request" tab to initiate a advancement request.</li>
              <li>Find the target event you want to promote entries to and submit the request by clicking the "Request Link" button.</li>
            </ol>
            <h6>Approve Permission</h6>
            <ol>
              <li>Select the "Requests to Approve" tab to view incoming advancement requests.</li>
              <li>Review the advancement requests submitted by other events.</li>
              <li>Approve or deny the requests based on your event's criteria.</li>
              <li>Notify the requesting event of your decision.</li>
            </ol>
          </div>
        </TabPanel>
        <TabPanel>{data && <PromoteWizard data={data} 
        onPromoted={() => {
          setTabIndex(2);
        }} />}</TabPanel>

        <TabPanel>
          <PromotionHistory />
        </TabPanel>
        <TabPanel>
          <MakeARequest fairs={fairs} feedRequests={feedRequests} setFeedRequests={setFeedRequests} 
          Updated={init} />
        </TabPanel>
        <TabPanel>
          <RequestsToApprove fairs={fairs} feederRequests={feederRequests} setFeederRequests={setFeederRequests}
          Updated={init}  />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default FairPromotionLinkingContainer;
